import Carousel from "../components/sections/Carousel";
import FeatureList from "../components/sections/FeatureList";
import Form from "../components/sections/Form";
import { features, intro } from "../content/Home";

function Home() {
  return (
    <main className="flex-grow-1">
      <div className="container my-4 container-wide box-shadow" id="intro">
        <div className="row flex-column-reverse flex-md-row justify-content-center align-items-center pt-4 px-5">
          <div className="col-12 col-md-8">
            <p>
              {intro}
            </p>
          </div>
          <div className="col-12 col-md-3">
            <img
              src={process.env.PUBLIC_URL + "/images/intro_circle.png"}
              className="d-block mx-auto img-fluid box-shadow"
              alt="Intro portrait"
              width={150}
              style={{ borderRadius: "50%" }}
              loading="lazy"
            />
          </div>
        </div>
        <div className="row flex-md-row-reverse justify-content-center align-items-center pb-4 px-5">
          <div className="col-12 col-md-11 d-grid gap-2 d-md-flex justify-content-md-start">
            <a href="/bemutatkozas" className="icon-link palegreen">
              Részletek
              <i className="bi bi-chevron-right palegreen" />
            </a>
          </div>
        </div>
      </div>
      <div
        className="container px-4 pt-5 pb-xxl-5 my-4 features container-wide box-shadow"
        id="features"
      >
        <div className="row">
          <div className="col-0" />
          <div className="col">
            <h1 className="mx-0 mx-md-5 pb-2 border-bottom palegreen">
              Gyógyszer vagy ...
            </h1>
          </div>
          <div className="col-1" />
        </div>
        <FeatureList items={features}/>
        <Carousel items={features} />
      </div>
      <Form />
    </main>
  );
}

export default Home;
